// FORMAT PRODUCT ITEM FOR CART
export function userAdressFormater(item) {
  return {
    entityId: item.entity_id ?? "",
    city: item.city ?? "",
    postalcode: item.postcode,
    phone: item.telephone ?? "",
    elevator: parseInt(item.elevator) === 1 ? "yes" : "no",
    floor: parseInt(item.upper_floor) === 1 ? "yes" : "no",
    adresse: item.street ?? "",
  };
}
